import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetScanTunnelSessionsQueryVariables = Types.Exact<{
  scanTunnelId: Types.Scalars['ID'];
}>;


export type GetScanTunnelSessionsQuery = { __typename?: 'Query', getScanTunnelSessions: Array<{ __typename?: 'ScanTunnelSession', id: string, is_active: boolean, active_until?: string | null }> };


export const GetScanTunnelSessionsDocument = gql`
    query GetScanTunnelSessions($scanTunnelId: ID!) {
  getScanTunnelSessions(scan_tunnel_id: $scanTunnelId) {
    id
    is_active
    active_until
  }
}
    `;

/**
 * __useGetScanTunnelSessionsQuery__
 *
 * To run a query within a React component, call `useGetScanTunnelSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScanTunnelSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScanTunnelSessionsQuery({
 *   variables: {
 *      scanTunnelId: // value for 'scanTunnelId'
 *   },
 * });
 */
export function useGetScanTunnelSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetScanTunnelSessionsQuery, GetScanTunnelSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScanTunnelSessionsQuery, GetScanTunnelSessionsQueryVariables>(GetScanTunnelSessionsDocument, options);
      }
export function useGetScanTunnelSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScanTunnelSessionsQuery, GetScanTunnelSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScanTunnelSessionsQuery, GetScanTunnelSessionsQueryVariables>(GetScanTunnelSessionsDocument, options);
        }
export type GetScanTunnelSessionsQueryHookResult = ReturnType<typeof useGetScanTunnelSessionsQuery>;
export type GetScanTunnelSessionsLazyQueryHookResult = ReturnType<typeof useGetScanTunnelSessionsLazyQuery>;
export type GetScanTunnelSessionsQueryResult = Apollo.QueryResult<GetScanTunnelSessionsQuery, GetScanTunnelSessionsQueryVariables>;